﻿import React from "react";

const SimplePopover = React.memo((props: { markup: string, className?: string }) => {    
    const classes = `popover popover-simple position-relative ${props.className}`;
    return (<div className={classes} dangerouslySetInnerHTML={{ __html: props.markup }}>
    </div>);
});

export { SimplePopover };